import { render } from "./RegistrationInfoReSendEmail.vue?vue&type=template&id=0ea48632&scoped=true"
import script from "./RegistrationInfoReSendEmail.vue?vue&type=script&lang=js"
export * from "./RegistrationInfoReSendEmail.vue?vue&type=script&lang=js"

import "./RegistrationInfoReSendEmail.vue?vue&type=style&index=0&id=0ea48632&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ea48632"]])

export default __exports__